import React, { FC } from 'react';
import { Button, Callout, Icon } from 'components/atoms';
import { ActionMenuItem, ActionMenuContainer } from './ActionMenu.styles';
import { ActionMenuProps } from './types';

const ActionMenu: FC<ActionMenuProps> = ({
  actions,
  name,
  ellipsisColour = 'black',
  label = null,
  renderIcon,
}) => (
  <Callout
    direction="left"
    name={name}
    maxHeight="none"
    trigger={() =>
      label ? (
        <Button text dark>
          {label}
        </Button>
      ) : (
        <Icon icon="more" aria-hidden size="xs" colour={ellipsisColour} />
      )
    }
  >
    <ActionMenuContainer>
      {actions.map(({ icon, name, onClick }) => (
        <ActionMenuItem key={name} onClick={onClick}>
          {renderIcon ? renderIcon : <Icon icon={icon} aria-hidden size="xxxs" />}
          {name}
        </ActionMenuItem>
      ))}
    </ActionMenuContainer>
  </Callout>
);

export default ActionMenu;
